import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getImageURL } from 'volto-ministerio-publico-federal/helpers/Image/Image';

const ImageBanner = ({ image, alt = '' }) => {
  const src = useMemo(() => {
    const item = Array.isArray(image) ? image?.[0] : null;

    if (!item) return '';

    try {
      const url = getImageURL(item, 'huge');
      return url ? flattenToAppURL(url) : '';
    } catch (e) {
      return '';
    }
  }, [image]);

  if (!src) return null;

  return (
    <Image
      className="mpf-banner-topo__image"
      src={src}
      alt={alt}
      loading="lazy"
      draggable={false}
    />
  );
};

ImageBanner.propTypes = {
  image: PropTypes.arrayOf(PropTypes.object),
  alt: PropTypes.string,
};

export default memo(ImageBanner);
